import { render, staticRenderFns } from "./AreasRefugio.vue?vue&type=template&id=25c4f187&lang=pug&"
import script from "./AreasRefugio.vue?vue&type=script&lang=js&"
export * from "./AreasRefugio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports